var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUkIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_697_5802)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 15.632C0 8.39117 0 4.77081 2.24942 2.52139C4.49884 0.271973 8.1192 0.271973 15.36 0.271973H16.64C23.8808 0.271973 27.5011 0.271973 29.7506 2.52139C32 4.77081 32 8.39117 32 15.632V16.912C32 24.1528 32 27.7731 29.7506 30.0226C27.5011 32.272 23.8808 32.272 16.64 32.272H15.36C8.1192 32.272 4.49884 32.272 2.24942 30.0226C0 27.7731 0 24.1528 0 16.912V15.632Z",
    fill: "#325046"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0267 23.3254C9.73341 23.3254 5.57348 18.3254 5.40015 10.0054H9.05348C9.17348 16.112 11.8667 18.6987 14.0001 19.232V10.0054H17.4402V15.272C19.5469 15.0454 21.7599 12.6454 22.5066 10.0054H25.9467C25.3733 13.2587 22.9733 15.6587 21.2667 16.6454C22.9733 17.4454 25.7068 19.5387 26.7468 23.3254H22.96C22.1467 20.792 20.1202 18.832 17.4402 18.5654V23.3254H17.0267Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_697_5802"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.271973)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUkIcon);
export default __webpack_public_path__ + "static/media/UkIcon.105c4034a7b5dc3d969b4665ebb0239e.svg";
export { ForwardRef as ReactComponent };